var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewsCover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1437.2,
    height: 1257.037,
    viewBox: "0 0 1437.2 1257.037",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5650",
    "data-name": "Path 5650",
    d: "M6095.819,2922.285S5743,3036.693,5399.988,3046.1c-14.6.4-31.479,57.117-31.479,57.117s-9.534-56.512-27.544-57.117c-341.7-11.47-682.347-123.817-682.347-123.817l30.369,1257.037s306.186-140.657,651.978-140.657c9.856,0,27.544-60.649,27.544-60.649s21.71,60.093,31.479,60.649c327.168,18.6,671.321,140.657,671.321,140.657Z",
    transform: "translate(-4658.619 -2922.285)",
    fill: "#93a750"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsCover);
export default __webpack_public_path__ + "static/media/NewsCover.ff89efc66ce61772b2c63dc082668826.svg";
export { ForwardRef as ReactComponent };